import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { MessagingService } from "../../core/messaging/messaging.service";
import { SeverityType } from "../../core/messaging/severity-type.enum";
import { ArrayHelper } from "../../utilities/contracts/array-helper";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { ChartService } from "../api/chart-lake/chart.service";
import { AlertNotification } from "./alert-notification.model";
import { NotificationItem } from "./notification-item.model";
import { NotificationType } from "./notification-type.enum";
import { NotificationService } from "./notification.service";


@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class NotificationComponent implements OnInit {

  notificationList: NotificationItem[];
  iconName = "ellipsis-v";
  rows: number;
  totalRecords: number;
  startRecord = 0;
  endRecord = 15;
  recordPerPage = 15;
  notificationsList: NotificationItem[];

  constructor(private readonly service: NotificationService,
              private readonly chartService: ChartService,
              private readonly messagingService: MessagingService,
              private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.getAllNotification();
  }

  changeDet(): void {
    this.changeDetector.markForCheck();
  }

  trackByIndex(index, item) {
    return index;
  }

  getUrl(): void {

  }

  onPageChange(event) {
    this.startRecord = ((event.page) * this.recordPerPage) + 1;
    this.endRecord = this.startRecord + (this.recordPerPage - 1);
    this.getAllNotification(this.startRecord, this.endRecord);
  }

  getAllNotification(startRecord?: number, endRecord?: number) {
      this.service
      .getAllNotification(this.startRecord, this.endRecord)
      .subscribe(items => {
        this.notificationList = items;
        this.totalRecords = items[0].NotificationGroup[0].recordCount;
        this.rows = this.recordPerPage;
        this.changeDet();
      });
  }

  isMentionAlert(item: AlertNotification): boolean {
    return item.alertTypeId === NotificationType.AT_MENTION && !!item.supplemental && item.supplemental.qualifiers?.length > 0;
  }

  onDownloadChartClick(event: Event, item: AlertNotification): void {
    event.preventDefault();
    const jobId = item.supplemental?.qualifiers.find(q => q.name === "jobId")?.id;
    if (StringHelper.isAvailable(jobId) && item.alertTypeId === 5) {
      this.chartService.getPresignedDownloadUrl(jobId).subscribe((url: string) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } else {
      // do nothing
      this.messagingService.showMessage("Download failed.", SeverityType.ERROR);
    }
  }
  }
